import { connect }         from 'react-redux';
import { Dispatch }        from "redux";
import { ActionTypes }     from 'actions/types';
import { reducerType }     from 'reducer';
 import Menu               from './Menu';
import useItemIsDD         from './useItemIsDD';
import { words }           from 'utils/dictionary';
import ArrowDropDownIcon   from '@mui/icons-material/ArrowDropDown';
import { ClickAwayListener } from '@mui/base/ClickAwayListener';
import useDDStyle          from './useDropDownStyle';
import { sizeStateType }   from 'reducer/types';
import { userInfoType }    from 'types';
import { makeStyles }      from 'makeStyles';


var clsx = require('classnames')


const useStyles = makeStyles()(() => ({
    selector: {
      width:      60,
      display:    'flex',
      alignItems: 'center',
      textAlign:  'center',
      cursor:     'pointer',
      zIndex:     99999,
    },
    iconContainer: {
      fontWeight: 'bold',
      '&:hover': {
        opacity: 0.5,
      }
    },
    small: {
      fontSize: 15,
    },
    big: {
      fontSize: 19,
    },
    menu: {
      position:        'absolute',
      border:          '1px solid #D3D4D5',
      backgroundColor: '#F00',
      overflowX:       'hidden',
      boxShadow:       '0px 4px 10px rgba(0,0,0,0.15)',
      transition:      'height 0.3s, opacity 0.4s',

     '&::-webkit-scrollbar': {
        width: '5px',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#CCC',
        borderRadius:    10
      } 
    },
    title: {
      height:         50,
      width:          '100%',
      minWidth:       250,
      display:        'flex',
      alignItems:     'center',
      justifyContent: 'center',
      textAlign:      'center',
      fontWeight:     'bold',
      paddingLeft:    5,
      paddingRight:   5,
      cursor:         'default',
    },
    item: {
      height:       50,
      width:        '100%',
      minWidth:     250,
      display:      'flex',
      alignItems:   'center',
      textAlign:    'left',
      paddingLeft:   5,
      paddingRight:  5,
      cursor:     'pointer',
      '&:hover': {
        backgroundColor: '#E6E6EA'
      }
    },
    filter: {
      position:        'fixed',
      left:            0,
      backgroundColor: 'rgba(0,0,0,0.1)',
      transition:      'opacity 0.3s'
    },
    links: {
      '&:hover': {
        opacity: 0.5
      }
    }
}))

type DropDownProps = {
  sizeState:       sizeStateType;
  userInfo:        userInfoType;
  dropDownItems:   string[];
  variant:         string;
  lang:            string;
  manualVal:       string;
  openDropDown:    string;
  manualOn:        boolean;
  setOpenDropDown: (val: string) => void;
  handlePageClick: (val: string) => void;
}

const DropDown: React.FC<DropDownProps> = ({ 
  sizeState,
  userInfo,
  dropDownItems,
  variant,
  lang,
  manualOn,
  manualVal,
  openDropDown,
  setOpenDropDown,
  handlePageClick,
}) => {

  const { classes } = useStyles();

  const DDItem = useItemIsDD(variant);

  const selectorClick = () => {

    import("./selecorClick").then(func => {
      func.selectorClick(variant, openDropDown, userInfo, setOpenDropDown)
    }); 
  }

  const handleItemClick = (val: string, ind: number) => {
    import("./itemClick").then(func => {
      func.itemClick(variant, val, ind, setOpenDropDown, handlePageClick)
    }); 
  }


  const handleClickAway = () => {
    if ( openDropDown === variant ) {
      setOpenDropDown('') 
    }
  }


  const { 
    selectorStyle, 
    menuStyle, 
    iconContainerStyle, 
    iconStyle, 
    filterStyle 
  } = useDDStyle(
    dropDownItems,
    variant,
    openDropDown,
    manualOn,
    manualVal
  )


  return (
    <>
        <div 
          className = { classes.filter }
          style     = { filterStyle }
        />
        <ClickAwayListener onClickAway = { handleClickAway }>
            <div 
               className = { clsx(classes.selector, ( sizeState.wideScreen ? classes.big : classes.small)) }
               style     = { selectorStyle }
            >
              {
                (variant === 'default' || (!sizeState.wideScreen && DDItem)) &&
                <div 
                  className = { classes.iconContainer }
                  style     = { iconContainerStyle }
                  onClick   = { selectorClick }
                >
                    <ArrowDropDownIcon style = { iconStyle }/>
                </div>
              }
              {
                sizeState.wideScreen && DDItem &&
                <div 
                  className = { classes.links }
                  onClick   = { selectorClick }
                >
                  { words[variant][lang] }
                </div>
              }
              <Menu
                sizeState       = { sizeState }
                menuStyle       = { menuStyle }
                dropDownItems   = { dropDownItems }
                variant         = { variant }
                lang            = { lang }
                manualVal       = { manualVal }
                manualOn        = { manualOn }
                handleItemClick = { handleItemClick }
              />      
            </div>
        </ClickAwayListener>
    </>
  );
}



const mapStateToProps = (reducer: reducerType) => {

  return {
    lang:      reducer.components.lang,
    sizeState: reducer.size,
    userInfo:  reducer.data.userInfo
}};

const mapDispatchToProps = (dispatch: Dispatch<ActionTypes>) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(DropDown);